import { render, staticRenderFns } from "./dialogHelp2dFish.vue?vue&type=template&id=33ce7ccc&scoped=true&"
import script from "./dialogHelp2dFish.vue?vue&type=script&lang=js&"
export * from "./dialogHelp2dFish.vue?vue&type=script&lang=js&"
import style0 from "./dialogHelp2dFish.vue?vue&type=style&index=0&id=33ce7ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce7ccc",
  null
  
)

export default component.exports